export const GET_PAY_TRANSACTION_QUERY = `query getPayTransaction ($limit: Int, $offset: Int, $conditions: pay_transaction_bool_exp = {}) {
  pay_transaction(limit: $limit, offset: $offset, where: { _and: [$conditions]}) {
    id
    status
    created_at
    created_by
    created_by_details {
      email
      name
      created_at
      external_id
    }
  }
  pay_transaction_aggregate (where: { _and: [$conditions]}) {
    aggregate {
      count
    }
  }
}`;

export const GET_MD_COUNTRIES_QUERY = `query getMDCountries {
  md_country {
    description
    value
  }
}`;
